import { useContext } from 'react';
import BrandContext from '@quno/patient-journey/src/context/BrandContext';
import type { BrandContextType } from '@quno/patient-journey/src/context/BrandContext';

export const useBrand = (): BrandContextType => useContext(BrandContext);
